import { SelectableGroupField, FieldInfoGroupField } from '@app/common/configurable-wizards';
import { Field } from '@app/common/configurable-wizards/types';

export type FindFieldResult = Field | null;

export const findField = (
  fields: Array<Field> | undefined,
  predicate: (curr: Field) => FindFieldResult,
): FindFieldResult => {
  if (fields?.length) {
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < fields.length; i++) {
      // Base recusion case
      const curr = fields[i];
      const baseResult = predicate(curr);

      // Break the loop and recursion
      if (baseResult) {
        return baseResult;
      }

      // Step into subFields
      const subFields = (curr as FieldInfoGroupField).subFields || (curr as SelectableGroupField).fieldGroups;
      const chainResult = findField(
        subFields as Array<Field>,
        predicate,
      );

      // Break the loop and return result
      if (chainResult) {
        return chainResult;
      }
    }
  }

  return null;
};
